/**
 * Shared stash for issueIds from saved-view / deep-link navigation.
 * Home consumes these once releaseData is ready; saved-view open stashes
 * before URL query params are cleared so React batching cannot drop them.
 */
let pendingIssueIds: string[] | null = null;

export function stashPendingRoadmapIssueIds(issueIds: string[]): void {
  pendingIssueIds = issueIds;
}

export function peekPendingRoadmapIssueIds(): string[] | null {
  return pendingIssueIds;
}

export function consumePendingRoadmapIssueIds(): string[] | null {
  const ids = pendingIssueIds;
  pendingIssueIds = null;
  return ids;
}
